var map = {
	"./10_yellow.mp3": "5cda",
	"./11_green.mp3": "fa88",
	"./13_pink.mp3": "5300",
	"./14_orange.mp3": "f0d9",
	"./8_blue.mp3": "f8dd",
	"./M_Brilliant.mp3": "05bc",
	"./M_Excellent.mp3": "0daf",
	"./M_Fantastic.mp3": "5d8f",
	"./M_Great.mp3": "0d93",
	"./M_Perfect.mp3": "1f52",
	"./M_Think again.mp3": "37bc",
	"./M_Try again.mp3": "6130",
	"./M_Very good.mp3": "64fe",
	"./M_Well done.mp3": "3e76",
	"./M_Work harder.mp3": "f968",
	"./click.mp3": "6fa6",
	"./false.mp3": "3198",
	"./true.mp3": "47dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b95e";